var map = {
	"./cie/logo-dark.svg": 1053,
	"./cie/logo-white.svg": 1054,
	"./cie/logo.svg": 1055,
	"./ciss-icons/amh/amhSanta.svg": 1056,
	"./ciss-icons/amh/solid.svg": 1057,
	"./ciss-icons/amh/text-landscape.svg": 1058,
	"./ciss-icons/amh/text-large.svg": 1059,
	"./ciss-icons/amh/transparent.svg": 1060,
	"./ciss-icons/amh/white.svg": 1061,
	"./ciss-icons/diary/solid.svg": 1062,
	"./ciss-icons/diary/transparent.svg": 1063,
	"./ciss-icons/diary/white.svg": 1064,
	"./ciss-icons/directory/solid.svg": 1065,
	"./ciss-icons/directory/transparent.svg": 1066,
	"./ciss-icons/directory/white.svg": 1067,
	"./ciss-icons/vaks/solid.svg": 1068,
	"./ciss-icons/vaks/transparent.svg": 1069,
	"./ciss-icons/vaks/white.svg": 1070,
	"./flags/aboriginal.svg": 1071,
	"./flags/lgbt.svg": 1072,
	"./flags/torres-strait.svg": 1073,
	"./healthengine/logo-white.svg": 1074,
	"./healthengine/logo.svg": 1075,
	"./markers-svg/diary.svg": 1076,
	"./markers-svg/directory.svg": 1077,
	"./markers/diary.png": 1078,
	"./markers/directory.png": 1079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1052;